import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { ClassifierUrl } from './ClassifierUrl';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { ClassifierSchema, ClassifierValidFormDataType } from '../schema';

const postClassifier = (classifier: ClassifierValidFormDataType) =>
  apiClient
    .post(
      expand(ClassifierUrl.CLASSIFIER, {}),
      ClassifierSchema.parseMutationDto(classifier)
    )
    .then((response) => response.data);

const patchClassifier = (
  id: number,
  classifier: Partial<ClassifierValidFormDataType>,
  headers?: HttpHeaders
) =>
  apiClient
    .patch(
      expand(ClassifierUrl.CLASSIFIER, { id }),
      ClassifierSchema.parseMutationDto(classifier),
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

const deleteClassifier = (id: number) =>
  apiClient
    .delete<void>(expand(ClassifierUrl.CLASSIFIER, { id }))
    .then((response) => response.data);

export const useMutateClassifierQuery = createApiMutationHook(
  ['classifier'],
  getMutationFn(postClassifier, patchClassifier, deleteClassifier)
);
